export enum TermsConditionType {
  Country = "Country",
  Company = "Company",
  Supplier = "Supplier"
}
